import React, { useState, useEffect } from 'react';
import "./SupplierLayout.scss";
import { Layout, Menu, Grid } from 'antd';
import { ShopOutlined } from '@ant-design/icons';
import {
  InboxOutlined,
  UserOutlined,
  SwapOutlined,
  LogoutOutlined
} from '@ant-design/icons';
import { Link, useNavigate } from 'react-router-dom';
import Forbidden from "../../components/Forbidden"
import MarketPlaceService from '../../utils/api/marketplace';


const { Sider, Content, Footer } = Layout;
const { SubMenu } = Menu;
const { useBreakpoint } = Grid;

export default function LayoutPage(props) {

  const { children } = props;

  const user = JSON.parse(localStorage.getItem('user'))
  let role = localStorage.getItem('role');
  let history = useNavigate();
  const [marketEnable, setMarketEnable] = useState(false)
  // const [notifications] = useState({
  //   notify: [],
  //   total: 0,
  //   user_id: ''
  // });
  const screens = useBreakpoint();
  const [collapsed, setCollapsed] = useState(true);

  useEffect(() => {
     MarketPlaceService.getVendorByUser(user.id)
      .then(() => setMarketEnable(true))
      .catch(() => setMarketEnable(false))
  
  }, [user.id])

  const logout = () => {
    history('/')
    localStorage.removeItem('token');
    localStorage.removeItem('role');
    localStorage.removeItem('user');
    localStorage.removeItem('fcm');
  }

  // const allNotifications = (
  //   <Menu >
  //     <Menu.ItemGroup title="Notificaciones">
  //       {notifications.total === 0 ? ( // Changed == to ===
  //         <Empty description="Sin notificaciones" image={Empty.PRESENTED_IMAGE_SIMPLE} />
  //       ) :
  //         notifications.notify.map((ntf) => (
  //           <Menu.Item key={ntf.id} style={{ backgroundColor: ntf.seen === 0 ? "#F7F7F7" : "", fontWeight: ntf.seen === 0 ? "bold" : "normal" }} icon={ntf.seen === 0 ? <EyeInvisibleOutlined style={{ fontSize: 20 }} /> : <EyeOutlined style={{ fontSize: 20 }} />}>

  //             <button style={{ background: 'none', border: 'none', textAlign: 'left', width: '100%', cursor: 'pointer' }} onClick={() => {}}>{ntf.title}-{ntf.description}</button>
  //           </Menu.Item>
  //         ))
  //       }
  //     </Menu.ItemGroup>
  //   </Menu>

  // );

  if (role === 6) {
    return (

      <Layout style={{ minHeight: "100vh" }}> 
        <Sider
          trigger={
            <div
              onClick={() => setCollapsed(!collapsed)}
              style={{
                backgroundColor: '#145F9D',
                color: 'white',
                padding: '10px',
                borderRadius: '0 10px 10px 0',
                cursor: 'pointer'
              }}
            >
              <SwapOutlined />
            </div>
          }
          collapsible
          collapsed={collapsed}
          onCollapse={(value) => setCollapsed(value)}
          breakpoint="lg"
          collapsedWidth={0}
          style={{
            backgroundColor: '#145F9D',
            position: 'fixed',
            height: '100vh',
            zIndex: 1000,
          }}
          width={screens.lg ? "14%": '60%'}
        >
          <div className="logo" />
          <Menu mode="inline" style={{backgroundColor: '#145F9D'}}>
            <Menu.Item key="1" icon={<InboxOutlined />} style={{ color: "#ffffff" }}><Link to='/orders/all/1'>Ordenes</Link> </Menu.Item>
            {marketEnable ? 
              <SubMenu key="sub2" icon={<ShopOutlined  style={{ color: "#ffffff" }} />} title="Marketplace" className='custom-submenu'>
              <>
                 
                <Menu.Item key="2" style={{ color: "#ffffff" }}>
                  <Link to='/marketplace'>Inicio</Link>
                </Menu.Item>
                
                <Menu.Item key="21" style={{ color: "#ffffff" }}>
                  <Link to={`/marketplace/suppliers/${user.id}`}>Perfil</Link>
                </Menu.Item>
                <Menu.Item key="22" style={{ color: "#ffffff" }}>
                  <Link to={`/marketplace/${user.id}/all-products`}>Mis Productos</Link> 
                </Menu.Item>
                <Menu.Item key="23" style={{ color: "#ffffff" }}>
                  <Link to={`/marketplace/${user.id}/orders`}>Órdenes de compra</Link>
                </Menu.Item>
              </>
          </SubMenu>
            : <></>}
            <Menu.Item
              key="profile"
              icon={<UserOutlined style={{color:'#ffffff'}}/>}
              style={{
                position: 'absolute',
                bottom: 40,
                width: '100%',
                color: "#ffffff"
              }}>
              <a href={user.id !== '' ? `/#/@p/${user.id}` : '#'} style={{ pointerEvents: user.id === '' ? 'none' : 'auto' }}> 
                Perfil
              </a>
            </Menu.Item>
            <Menu.Item
              key="logout"
              icon={<LogoutOutlined style={{color:'#ffffff'}}/>}
              onClick={logout}
              style={{
                position: 'absolute',
                bottom: 0,
                width: '100%',
                color: "#ffffff"
              }}
            >
              Salir
            </Menu.Item>
          </Menu>
        </Sider>
        <Layout style={{marginLeft:!collapsed ? "14%": '0%'}}>
          <Content
            className="site-layout-background"
            style={{
              margin: '24px 16px',
              padding: 24,
              minHeight: 280,
            }}
          >
            {children}
          </Content>
          <Footer style={{ textAlign: 'center' }}>Copyright ©2020 Created by EP&O</Footer>
        </Layout>

      </Layout>
    );
  } else {
    return <Forbidden />
  }
}